<template>
  <div class="MemberDemandPoolDetail _inner_center_1200 ">

    <!-- 需求面板 -->
    <div class="demand-panel">
      <h1 class="title overflow-one">{{ detail.title }}</h1>
      <UserMemberIcons class="UserMemberIcons" :item="detail"/>
      <!-- 进度 -->
      <div class="demand-schedule" v-if="detail.status !== 2">

        <div class="schedule-title">需求进度 <span class="txt-percent">（{{ detail._percentage }}%）</span></div>

        <div class="schedule-progress">

          <div class="progress-list">
            <div class="progress-item"
                 :class="{ 'ON': index ==  detail._percentage / 50}"
                 v-for="(item,index) in PROGRESS_LIST"
                 :key="index"
            >
              {{ item }}
            </div>
          </div>

          <no-ssr>
            <el-progress class="el-progress"
                         :percentage="detail._percentage"
                         :show-text="false"
                         :stroke-width="7"
                         color="rgba(255, 93, 110, 1)"
            ></el-progress>
          </no-ssr>
        </div>

        <div class="schedule-btn-group">
          <div class="btn-item"><i class="iconfont icon-jindu"></i>平面设计</div>
          <div class="btn-item"><i class="iconfont icon-people"></i>{{ detail.collect_users }}人同求</div>
        </div>

        <div class="submit-demand" @click="writeDemand">
          提新需求
        </div>


      </div>

      <!-- 需求信息 -->
      <div class="demand-info">
        <div class="demand-item" v-if="detail.status == 2">
          <div class="demand-item-label">需求状态</div>
          <div class="demand-item-value">
            {{ DEMAND_TASK_STATUS[detail.status] }} {{ (detail.remark) }}
          </div>
        </div>

        <div class="demand-item">
          <div class="demand-item-label">设计要求</div>
          <div class="demand-item-value">
            {{ detail.other_demand }}
          </div>
        </div>
        <div class="demand-item">
          <div class="demand-item-label">设计风格</div>
          <div class="demand-item-value">{{ detail.design_style }}</div>
        </div>


        <div class="demand-item demand-item-words" v-if="detail._keyword">
          <div class="demand-item-label">素材关键词</div>
          <div class="demand-item-value">
            <TupianKeywords
              :keyword-list="detail._keyword"
              maxNumber="10"
            />
          </div>
        </div>

        <div class="demand-item demand-item-share">
          <div class="demand-item-label">分享项目到</div>
          <div class="demand-item-value">
            <ShareByDemandPoolDetail :list="SHARE_ICONS"
                                     @shareWb="shareWb"
                                     @shareXhs="shareXhs"
                                     @copyLink="copyLink"
            />
          </div>
        </div>
      </div>

    </div>

    <!-- 需求图片示例图 -->
    <div class="demand-case-pics">

      <!-- swiper -->
      <div class="swiper-container"
           v-swiper:mySwiper="swiperOption"
           ref="mySwiper" id="my-handle"
           v-if="status"

      >
        <div class="swiper-wrapper" v-if="detail && detail.cover_img && detail.cover_img.length">
          <div class="swiper-slide"
               v-for="(item,index) in detail.cover_img"
               :key="index"
               @click="previewBanner(item)"

          >
            <img
              :src="CON_COMMON.CON_BASIC.BASE_IMG_URL + item.picUrl" alt="">

          </div>
        </div>
      </div>


      <!-- tupian预览 -->

      <el-image
        style="width: 100px; height: 100px;opacity: 0;"
        ref="preview"
        :src="url"
        :preview-src-list="detail._previewList"
      ></el-image>

      <!-- 左右切换箭头  -->
      <i
        v-show="swiperOption.initialSlide > 0"
        class="iconfont icon-a-arrowrightbold icon-a-arrowrightbold2"
        @click="swiperToggle('left')"
      />

      <i
        v-show="( detail.cover_img && detail.cover_img.length > 1 && swiperOption.initialSlide != detail.cover_img.length -1 )"
        class="iconfont icon-a-arrowrightbold"
        @click="swiperToggle('right')"
      />

      <!-- 会员专属icon -->
      <MembersOnlyTag class="MembersOnlyTag"/>

      <!-- 放大镜icon -->
      <div class="demand-img-glass"
           @click="previewBanner(detail.cover_img[swiperOption.initialSlide])"
      >
        <i class="iconfont icon-a-zoomin"/>
      </div>

    </div>

    <!-- 需求更新图片时间轴 -->
    <div class="demand-update-img-timeline"
         v-if="timelineList.length"
    >
      <div class="title">最近更新</div>

      <no-ssr>
        <el-timeline class="el-timeline">
          <el-timeline-item class="el-timeline-item"
                            v-for="(item,index) in timelineList"
                            :key="index"
          >
            <div class="timeline-date">
              <div class="date-month">{{ item.month }}</div>
              <div class="date-year">{{ item.year }}</div>
            </div>

            <!-- 重写圆球 -->
            <div class="timeline-ball">
              <i class="timeline-ball-inner"></i>
            </div>

            <div class="timeline-content">
              <div class="title">
                <i class="iconfont icon-qizi" v-if="index == timelineList.length-1"/>
                <i class="iconfont icon-a-12pack" v-else/>
                {{ item.message }}
                <span class="txt-integral" v-if="detail.status == 3 && index == 0 &&  detail.integral">（消耗积分{{ detail.integral }}）</span>
              </div>
              <PicList
                class="PicList"
                :pic-list="item.pictures"
                params="demandPool"
              />
            </div>
          </el-timeline-item>
        </el-timeline>
      </no-ssr>
    </div>

    <!-- 需求生产图片 -->
    <div class="demand-develop-pics">
      <RecommendedMaterial
        v-if="detail.relation_pic && detail.relation_pic.length"
        title="已完成素材"
        class="RecommendedMaterial"
        params="demandPool"
        :pic-list="detail.relation_pic"/>
    </div>

    <!-- 需求推荐相关素材 -->
    <div class="demand-recommend-pics">
      <RecommendedMaterial
        v-if="detail.recommend_pic && detail.recommend_pic.length"
        title="推荐素材"
        class="RecommendedMaterial"
        :pic-list="detail.recommend_pic"/>
    </div>

    <no-ssr>
      <!--  填写需求弹框 -->
      <DemandWriteDialog ref="DemandWriteDialog"/>

      <!--  非VIP需求拦截弹框 -->
      <ReminderDialog
        ref="ReminderDialog"
        btnTheme="FANS"
        @btnClick="btnClick"
        content-txt="需求池仅限潮国VIP提交"
        btn-txt="购买VIP"
      ></ReminderDialog>
    </no-ssr>

  </div>
</template>

<script>

/* 引入公共方法和常量 */
import * as fnCommon from '@/fn/_fn';
import * as CON_COMMON from '@/constant/_constant';

/* 引入组件 */

/* 引入VUEX */
import {mapState} from "vuex";
import {fnFans, fnLogin, fnUser} from "@/fn";
import _mixin from "@/pages/fans/demand-detail/_mixin";
import mixin from "@/pages/fans/common/mixin";
import * as swiperAni from "assets/swiper.animate";
import {getDemandDetail, getDemandDetailTimeline} from "@/api/fans/demand-pool";

/* 引入API */


/* 进度列表 */
const {DEMAND_TASK_STATUS, CHANNEL_ICON} = CON_COMMON.CON_CONFIG;
console.log(DEMAND_TASK_STATUS[0])
const PROGRESS_LIST = [
  DEMAND_TASK_STATUS[0],
  DEMAND_TASK_STATUS[1],
  DEMAND_TASK_STATUS[3],
]

/* 分享项目图标 */
const SHARE_ICONS = [
  CHANNEL_ICON.wb,
  CHANNEL_ICON.xhs,
  CHANNEL_ICON.link,
]


export default {
  name: "MemberDemandPoolDetail"
  , layout: "fans/fixed-header"
  , mixins: [_mixin, mixin]
  ,
  components: {}

  ,
  props: {}

  ,
  async asyncData({app}) {
    const {route} = app.context;
    let id = parseInt(route.params.id) || 1;

    let [
      detail,
      timelineList
    ] = await Promise.all([
      app.$api.getDemandDetail({id}),
      app.$api.getDemandDetailTimeline({id}),
    ])

    console.log('--timelineList.data')
    console.log(timelineList)
    return {
      id,
      detail: fnFans.disposeDemandDetail(detail.data),
      status: true,
      timelineList: timelineList.data
    }
  }

  ,
  mounted() {
    // this.getDemandDetailTimeline();
    // this.getDemandDetail();
  },
  watch: {}

  , computed: {}


  , data() {
    return {
      detail: {}
      , CON_COMMON
      , PROGRESS_LIST
      , DEMAND_TASK_STATUS
      , swiperOption: {
        initialSlide: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        eventsTarged: '#my-handle',
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        loop: false, // 在此无效？？？？？
        speed: 500,
        on: {
          slideChange: () => {
            const c_swiper = document.getElementsByClassName("swiper-container");
            this.swiperOption.initialSlide = c_swiper[0].swiper.activeIndex;
          },
        },
      }
      , SHARE_ICONS
      , timelineList: []  // 时间轴列表
      , status: false
      , url: ""
    }
  }

  , methods: {


    /* 测试渲染数据 */
    initTest() {

    }

    , getDemandDetail() {

      let id = parseInt(this.$route.params.id) || 1;
      getDemandDetail({
        'id': id
      }).then(res => {
        this.detail = fnFans.disposeDemandDetail(res.data.data);
        this.status = true
      })

    },

    /* 时间线 */
    getDemandDetailTimeline() {

      getDemandDetailTimeline({id: this.id}).then(res => {
        let {status, data} = res.data;
        if (status == 200) {
          this.timelineList = data;
        }
      })
    }


    /* 需求图片示例图模块 */
    , swiperToggle(type = 'right') {

      console.log('--swiperToggle')

      /* 向左 */
      let {initialSlide} = this.swiperOption
      let {cover_img} = this.detail

      if (type == 'left' || type == 0) {
        this.swiperOption.initialSlide -= 1;

        if (this.swiperOption.initialSlide < 0) {
          this.swiperOption.initialSlide = 0
        }
      }

      /* 向右 */
      if (type == 'right' || type == 1) {
        this.swiperOption.initialSlide += 1;
        if (this.swiperOption.initialSlide > cover_img.length - 1) {
          this.swiperOption.initialSlide = cover_img.length - 1
        }
      }


      if (process.client) {
        this.mySwiper.slideTo(this.swiperOption.initialSlide, 1000);
      }
    }

    , previewBanner(item) {
      this.url = CON_COMMON.CON_BASIC.BASE_IMG_URL + item.picUrl;
      this.$refs.preview.clickHandler();
    }

    , shareWb() {
      const {cover_img, title} = this.detail;
      const shareUrl = window.location.href;
      const shareTitle = title;
      const shareCover = cover_img.length ? CON_COMMON.CON_BASIC.BASE_IMG_URL + cover_img[0].picUrl : "";

      fnCommon.fnBasic.shareByWeibo(shareUrl, shareTitle, shareCover);
    }
    , shareXhs() {
      fnCommon.fnBasic.navigationTo(CON_COMMON.CON_BASIC.SHARE_CODE_BY_RED_BOOK)
    }
    , copyLink() {
      const shareTxt = "我的设计需求在【潮国创意】免费帮忙实现啦！宠粉福利嘎嘎好！一起提需求吧：" + window.location.href
      fnCommon.fnBasic.copy(shareTxt)
    }

    /* 提需求 */
    , async writeDemand() {
      /* 检查是否是会员 */
      let _temFlag = await fnUser.getAccountIsVip();
      if (!fnLogin.checkLogin()) {
        fnLogin.loginIntercept()
        return false
      }
      if (_temFlag) {
        if (this.$refs.DemandWriteDialog) {
          this.$refs.DemandWriteDialog.isShow = true
        } else {
          console.error('检查 填写设计需求组件是否存在')
        }
      } else {
        this.$refs.ReminderDialog.isShow = true
      }
    }

  }

}
</script>

<style lang="scss" scoped>

.MemberDemandPoolDetail {
  position: relative;
  margin-top: 76px;
}


/* 需求面板 */
.demand-panel {
  width: 520px;
  height: 480px;
  min-height: 480px;
  border-radius: 20px;
  margin: 0 0 88px;
  padding-top: 43px;


  .title {
    width: 423px;
    height: 29px;
    font-size: 22px;
    font-weight: bold;
    color: #0A2540;
    line-height: 29px;
    margin-bottom: 20px;
  }

  .UserMemberIcons {
    margin-bottom: 28px;
  }

  .demand-schedule {
    width: 468px;
    height: 172px;
    background: linear-gradient(270deg, rgba(255, 243, 239, 0) 0%, rgba(255, 243, 239, 0.6) 100%);
    border-radius: 14px;
    margin-bottom: 32px;
    padding: 23px 24px 0;
    box-sizing: border-box;
    position: relative;


    .schedule-title {
      height: 22px;
      font-size: 16px;
      color: #2D2B33;
      line-height: 21px;
      margin-bottom: 16px;

      .txt-percent {
        height: 16px;
        font-size: 12px;
        color: #2D2B33;
        line-height: 16px;
        margin-left: 4px;
      }
    }

    .schedule-progress {
      margin-bottom: 23px;

      .progress-list {
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;

        .progress-item {
          height: 18px;
          font-size: 13px;
          color: #596080;
          line-height: 17px;
          cursor: pointer;

          &.ON {
            color: $color-fans;
          }
        }
      }
    }

    .schedule-btn-group {
      display: flex;

      .btn-item {
        height: 24px;
        background: #FFFFFF;
        border-radius: 13px;
        display: flex;
        align-items: center;
        padding: 0 10px;
        color: rgba(123, 128, 154, 1);
        margin-right: 14px;

        &:last-child {
          margin-right: 0;
        }

        .iconfont {
          font-size: 16px;
          margin-right: 6px;
        }

        .icon-jindu {
        }

        .icon-user-profile {
        }
      }
    }

    .submit-demand {
      width: 124px;
      height: 38px;
      background: #FFFFFF;
      border-radius: 20px;
      border: 1px solid #FF5D6E;
      font-size: 14px;
      color: #FF5D6E;
      display: flex;
      align-items: center;
      justify-content: center;
      @include Position(1, 3, 18px, 20px);
      @include ElementHover(#FFFFFF, $color-fans-hover)
    }

  }

  .demand-info {

    .demand-item {
      display: flex;
      margin-bottom: 18px;

      &:last-child {
        margin-bottom: 0;
      }

      .demand-item-label {
        width: 98px;
        font-size: 14px;
        color: rgba(89, 96, 136, 0.75);
        line-height: 20px;
      }

      .demand-item-value {
        max-width: 370px;
        font-size: 14px;
        color: #0A2540;
        line-height: 20px;
      }

      &.demand-item-words {
        .demand-item-label {
          line-height: 26px;
        }

        .demand-item-value {
          display: flex;
          align-items: center;
          flex-wrap: wrap;

          /deep/ a {
            &:hover {
              color: $color-fans !important;
              background: rgba(255, 242, 244, 1) !important;
            }
          }
        }
      }


    }

    .demand-item-share {
      display: flex;
      align-items: center;
      position: relative;
      z-index: 20;

    }
  }

}

/* 需求图片示例图 */
.demand-case-pics {
  width: 520px;
  height: 480px;
  border-radius: 20px;
  border: 1px solid #ECEFF6;
  @include Position(1, 2, 0, 48px);


  .MembersOnlyTag {
    @include Position(1, 2, 16px, 16px);
  }


  .swiper-container {
    height: 100%;

    .swiper-wrapper {
      height: 100%;

      .swiper-slide {
        height: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        /*&.img-big{
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 100%;
            !*width: 223px;
            //height: 100%;
            @include Position(1, 5, 50%, 0);
            transform: translateX(-50%);*!
          }
        }
        &.img-small{
          display: flex;
          align-items: center;
          justify-content: center;
        }*/


        img {
          //width: 100%;
          display: flex;
          height: 100%;
          position: relative;
          z-index: 3;
          max-height: 480px;
        }


      }
    }
  }


  .demand-img-glass {
    @include Position(1, 3, 16px, 16px);
    cursor: pointer;
    z-index: 20;


    .icon-a-zoomin {
      font-size: 20px;
      color: #636A87;
      //pointer-event:auto;

      &:hover {
        color: $color-fans;
      }
    }
  }


  .icon-a-arrowrightbold {
    width: 36px;
    height: 36px;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px 0px rgba(10, 37, 64, 0.1000);
    @include Position(1, 2, -18px, 50%);
    transform: translateY(-50%);
    border-radius: 50%;
    font-size: 20px;
    line-height: 36px;
    text-align: center;
    z-index: 2;

    @include ElementHover(#FFFFFF, $color-fans);

    &.icon-a-arrowrightbold2 {
      @include Position(1, 4, -18px, 50%);
      transform: translateY(-50%) rotate(180deg);
    }
  }
}


/* 需求更新图片时间轴 */
.demand-update-img-timeline {
  margin-left: 79px;
  width: 100%;
  margin-bottom: 28px;


  > .title {
    margin-bottom: 32px;
    height: 29px;
    font-size: 22px;
    font-weight: bold;
    color: #0A2540;
    line-height: 29px;
    letter-spacing: 1px;
    margin-left: -79px;
  }


  .el-timeline {

    .el-timeline-item {


      .timeline-date {
        width: 74px;
        @include Position(1, 5, -74px, -6px);

        .date-month {
          font-size: 16px;
          font-weight: bold;
          color: #424866;
          line-height: 21px;
          margin-bottom: 4px;
        }

        .date-year {
          height: 18px;
          font-size: 13px;
          color: #596088;
          line-height: 18px;
        }
      }


      /deep/ .el-timeline-item__node {
        opacity: 0 !important;
      }

      .timeline-ball {
        width: 10px;
        height: 10px;
        background: linear-gradient(223deg, #B7BCCC 0%, #C8CDDF 100%);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        @include Position(1, 5, 0, 3px);

        .timeline-ball-inner {
          width: 4px;
          height: 4px;
          background: #FFFFFF;
          border-radius: 50%;
        }
      }

      .timeline-content {
        position: relative;
        top: -3px;

        .title {
          font-size: 15px;
          color: #0A2540;
          line-height: 22px;
          margin-bottom: 26px;

          .iconfont {
            font-size: 18px;
            color: $color-fans;
            margin-right: 17px;
          }
        }

        .txt-integral {
          font-size: 13px;
          color: #596088;
          line-height: 22px;
          margin-left: 4px;
        }
      }
    }

  }

  /deep/ .el-timeline {

    .el-timeline-item__timestamp {
      @include Position(1, 5, -100px, 0);
    }

  }

  .PicList {
    /deep/ .inner_center {
      width: 1200px !important;
    }

    /deep/ .PicItem {
      width: 252px !important;
      height: 329px !important;
      margin: 0 28px 28px 0;

      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
}


/* 需求生产图片 */
.demand-develop-pics {
  margin-bottom: 28px;
}

/* 需求推荐相关素材 */
.demand-recommend-pics {
  padding-bottom: 45px;

}


</style>


















